/* eslint-disable*/
import { getUserStatusByEmail } from '@/assets/controllers/ApiSocioController';
import LocaleController from '@/assets/controllers/LocaleController';
import RequestModule from '@/assets/libs/requestModule';
import { notify } from '@kyvg/vue3-notification';
import axios from 'axios';
import moment from 'moment';

/**
 * Debounce function, taken from Underscore.js
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean} immediate
 */
var debounce = function (func, wait, immediate, context) {
    this.timeout = null;

    return function () {
        context = context || this;
        var args = arguments;
        var later = function (resolve) {
            if (!immediate) return resolve(func.apply(context, args));
        };
        var callNow = immediate && !this.timeout;
        clearTimeout(this.timeout);

        if (callNow) {
            return Promise.resolve(func.apply(context, args));
        } else {
            return new Promise((resolve) => {
                this.timeout = setTimeout(() => later(resolve), wait);
            });
        }
    };
};
debounce.timeout = null;
debounce.clearDebounce = () => {
    clearTimeout(debounce.timeout);
};

// Função auxiliar para mapear o plano do sócio (integração genérica) com o tipo de consumidor
export async function mapPlanoToConsumerType(user, email) {
    try {
        const responseApiFlamengo = await getUserStatusByEmail(email);
        const responseConsumerTypes = await RequestModule.postRequest('consumer/get-consumer-types');

        // mock data
        // const responseConsumerTypes = {
        //     data: [
        //         {
        //         consumerType: '02',
        //         description: 'DELIVERY',
        //         externalCode: '1c9b172de533f5422fd04b7eaa056ecc'
        //         }
        //     ]
        // };

        const idPlano = responseApiFlamengo?.data?.contrato?.idplano;
        const statusContrato = responseApiFlamengo?.data?.status_contrato;
        if (!idPlano) {
            console.warn('Plano do sócio torcedor não encontrado.');
            user.consumerType = 'T';
            user.idPlano = null;
        } else if (statusContrato.toLowerCase() !== 'ativo') {
            console.warn(`O status do contrato encontra-se desativado.`);
            //user.consumerType = 'T';
            user.idPlano = idPlano;
        } else {
            const tiposConsumidor = responseConsumerTypes.data || [];
            const tipoCorrespondente = tiposConsumidor.find((tc) => tc.EXTERNALCODE === idPlano);

            if (tipoCorrespondente) {
                console.log('Tipo de consumidor correspondente encontrado!');
                user.consumerType = tipoCorrespondente.CONSUMERTYPE;
                user.contractName = responseApiFlamengo?.data?.contrato?.plano;
                user.idPlano = idPlano;
            } else {
                console.warn(`Nenhum tipo de consumidor encontrado com externalCode igual a ${idPlano}`);
                //user.consumerType = 'T';
                user.idPlano = idPlano;
            }
        }
    } catch (error) {
        console.warn('Erro ao tentar mapear tipo de consumidor:', error);
        //user.consumerType = 'T';
        return {
            error: true,
            message: 'Erro ao tentar mapear tipo de consumidor.'
        };
    }

    return user;
}

// Get the element with the highest occurrence in an array
const mode = function (arr) {
    return arr.sort((a, b) => arr.filter((v) => v === a).length - arr.filter((v) => v === b).length).pop();
};

const modeLength = function (arr) {
    return arr.filter((e) => e === mode(arr)).length;
};

/**
 * @param {String} baseStr
 * @param {String} maskStr
 * @param {String} char
 */
const insertChar = (baseStr, maskStr) => {
    if (baseStr === undefined || baseStr === null) {
        return undefined;
    }
    var newStr = '';
    var offset = 0;

    for (var i = 0; i < maskStr.length && i < baseStr.length + offset; i++) {
        if (maskStr[i] === '.') {
            newStr += '.';
            offset++;
        } else {
            newStr += baseStr[i - offset];
        }
    }
    return newStr;
};

const maskFactory = function (maskStr) {
    return function (o) {
        const value = o.value;
        return insertChar(value, maskStr);
    };
};

const showConfirmationDialog = function (modal, wrappedCallback = () => {}, text = '?', otherOptionCallback = () => {}) {
    modal.show(
        {
            template: `
            <div class="confirmation-dialog-box">
                <h5 class="title"> ${text} </h5>
                <div class="dialog-button-container">
                <button class="button-default modal btn-outlined" @click="handleNo"> ${LocaleController.getString('nao')} </button>
                <button class="button-default modal" @click="deleteValidity"> ${LocaleController.getString('sim')} </button>
                </div>
            </div>
        `,
            methods: {
                deleteValidity() {
                    wrappedCallback();
                    this.close();
                },
                handleNo() {
                    otherOptionCallback();
                    this.close();
                },
                close() {
                    this.$emit('close');
                }
            }
        },
        {},
        {
            height: 'auto',
            width: '600px'
        }
    );
};

const showInfoModal = function (text = '') {
    let modal = new Vue().$modal;
    let img = '';
    modal.show(
        {
            template: `
            <div class="confirmation-dialog-box">
                <div style="display: flex; justify-content: center">
                    <img src="${img}" style="width: 96px">
                </div>
                <h5 class="title" style="padding-top: 35px"> ${text.substring(0, 300)} </h5>
                <div class="dialog-button-container" style="display: block">
                    <button class="button-default modal" @click="close"> OK </button>
                </div>
            </div>
        `,
            methods: {
                close() {
                    this.$emit('close');
                }
            }
        },
        {},
        {
            height: 'auto',
            width: '600px'
        }
    );
};

let isInvalidNumber = (value) => {
    return value == null || value == undefined || value == NaN;
};

// Verifica um caso de exceção que existe na regra de imprime sim/não do FOS, que faz o preço do combo ser
// desconsiderado quando o normal, pela regra, seria considerar
const isFosException = function (product, fatherProductCode, firstLevelComboPrint, groupPrint) {
    let comboDoCombo = isComboDoCombo(product, fatherProductCode);
    let selledInsideHimself = isSelledInsideHimself(product);

    return /* firstLevelComboPrint && groupPrint && */ comboDoCombo && !selledInsideHimself;
};

const isComboDoCombo = (product, fatherProductCode) => {
    return product.subItemProductGroups.length > 0 && product.subItemCode !== fatherProductCode;
};

const isSelledInsideHimself = function (product) {
    let selledInsideHimself = false;
    let hasProductGroups = product && product.subItemProductGroups && product.subItemProductGroups.length > 0;
    if (hasProductGroups) {
        product.subItemProductGroups.forEach((subGroup) => {
            let hasItems = subGroup.subProductGroupItems && subGroup.subProductGroupItems.length > 0;
            if (hasItems) {
                subGroup.subProductGroupItems.forEach((subProd) => {
                    if (subProd.subItemCode === product.subItemCode) {
                        selledInsideHimself = true;
                    }
                });
            }
        });
    }
    return selledInsideHimself;
};

/**
 * @param {Array<Object>} array
 * @param {Array<String>} keys
 */
const sortBy = function (array = [], keys = []) {
    return array.sort((a, b) => {
        for (var i = 0; i < keys.length; i++) {
            const k = keys[i];
            let diff = a[k] - b[k];
            if (isNaN(diff)) {
                const subjectA = (!!a[k] && a[k]) || '';
                const subjectB = (!!b[k] && b[k]) || '';
                diff = subjectA.localeCompare(subjectB);
            }
            if (diff !== 0) {
                return diff;
            }
        }
        return 0;
    });
};

const formatMoney = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

const removeBlockedProds = function (prods) {
    let blockProds = getLocalVar('blockProds') || [];
    let filteredProds = (prods || []).filter((p) => blockProds.indexOf(p.subItemCode) === -1);
    filteredProds = removeHiddenProducts(filteredProds);
    filteredProds = removeHourlyUnavailableProds(filteredProds);
    return filteredProds;
};

const removeHiddenProducts = function (prods) {
    return (prods || []).filter((p) => p.productShowOnMenu != 'N');
};

const removeHourlyUnavailableProds = function (prods) {
    let hourlyUnavailableProds = getLocalVar('hourlyUnavailableProds') || [];
    let filteredProds = [];
    let isFirstLvlProd = prods && prods.length > 0 && prods[0].productCode !== undefined;

    if (isFirstLvlProd) {
        filteredProds = (prods || []).filter((p) => hourlyUnavailableProds.indexOf(p.productCode) === -1);
    } else {
        filteredProds = (prods || []).filter((p) => hourlyUnavailableProds.indexOf(p.subItemCode) === -1);
    }

    return filteredProds;
};

/**
 * Return values stored into localStorage.
 *
 * @param {String} varName
 */
const getLocalVar = function (varName) {
    const storedToken = localStorage.getItem(varName);
    try {
        if (storedToken) {
            return JSON.parse(storedToken);
        }
    } catch (e) {
        return null;
    }
};

const sleep = async (milis) => {
    return new Promise((resolve) => setTimeout(resolve, milis));
};

const interfaceVersionIsSupported = (interfaceVersion, minVersionSupported) => {
    try {
        const VERSION_PARTS = 3;
        let interfaceVersionParts = interfaceVersion.split('.');
        let minVersionParts = minVersionSupported.split('.');

        for (let i = 0; i < VERSION_PARTS; i++) {
            let interfaceVersionPart = interfaceVersionParts[i];
            let minVersionPart = minVersionParts[i];

            if (interfaceVersionPart.length > minVersionPart.length) {
                let zerosToAppend = interfaceVersionPart.length - minVersionPart.length;
                minVersionParts[i] = appendLeftZeros(minVersionPart, zerosToAppend);
            }

            if (minVersionPart.length > interfaceVersionPart.length) {
                let zerosToAppend = minVersionPart.length - interfaceVersionPart.length;
                interfaceVersionParts[i] = appendLeftZeros(interfaceVersionPart, zerosToAppend);
            }
        }

        interfaceVersion = parseInt(interfaceVersionParts.join(''));
        minVersionSupported = parseInt(minVersionParts.join(''));

        return interfaceVersion >= minVersionSupported;
    } catch (error) {
        console.error(error.message);
        return false;
    }
};

const appendLeftZeros = (stringToAppend, numberOfZeros) => {
    for (let i = 0; i < numberOfZeros; i++) {
        stringToAppend = '0' + stringToAppend;
    }
    return stringToAppend;
};

const updateDefaultConfigs = async function (config = null, force = false) {
    const urlMenuCache = this.getBackAdress();
    config = config ? config : this.getLocalVar('taaconfig');

    if (!config) {
        return false;
    }

    const now = moment();
    let lastTimeUpdatedConfig = config.lastTimeUpdatedConfig ? moment(config.lastTimeUpdatedConfig, 'DD/MM/YYYY HH:mm:ss') : null;
    let interval = 1;

    if (lastTimeUpdatedConfig) {
        interval = now.diff(lastTimeUpdatedConfig, 'days');
    }

    if (interval < 1 && !force) {
        return false;
    }

    config.lastTimeUpdatedConfig = moment().format('DD/MM/YYYY HH:mm:ss');

    const defaultColors = {
        primary_color: '#ff6821',
        primary_light: '#ff9a51',
        primary_dark: '#c43600',
        header_color: '#f8601a',
        categorie_color: '#ffffff',
        categorie_font_color: '#1e1f1f',
        cart_color: '#e2e1e1',
        cart_font_color: '#1e1f1f',
        price_font_color: '#ff0000'
    };

    const defaultImages = [
        'espera',
        'logo',
        'noImage',
        'pager',
        'balancascreen',
        'tapscreen',
        'maquininha',
        'impressora',
        'erroImpressora',
        'erroSalvarVenda',
        'erroTEF',
        'erroPinpad'
    ];

    const defaultParams = await axios.post(urlMenuCache + '/getDefaultParams', {}).then((r) => r.data);
    if (defaultParams && defaultParams.sucesso) {
        if (this.isAndroidMode()) removeVideos(defaultParams);

        Object.keys(defaultColors).forEach((e) => {
            if (defaultParams[e]) {
                config[e] = defaultParams[e];
            }
        });
        defaultImages.forEach((e) => {
            config.images[e] =
                !config.images[e] || config.images[e].includes('Default') ? defaultParams.images[e] : (config.images && config.images[e]) || '';
        });
        config.lastTimeUpdatedConfig = defaultParams.lastTimeUpdated;
    }

    this.setLocalVar('taaconfig', config);
    return defaultParams;
};

const removeVideos = (defaultParams) => {
    try {
        Object.keys(defaultParams.images).forEach((key) => {
            let isVideoFile =
                defaultParams.images[key].includes('.mp4') ||
                defaultParams.images[key].includes('.mkv') ||
                defaultParams.images[key].includes('.webm');

            if (isVideoFile) defaultParams.images[key] = '';
        });
    } catch (error) {
        console.log('Não foi possível remover todos os vídeos das imagens - Pode ocasionar erros na versão Android');
        console.log(error.message);
    }
};

const sanitizeNumber = (value) => {
    return ('' + value).replace(/\D/g, '');
};

const findCep = async (cep) => {
    cep = sanitizeNumber(cep);

    if (cep.length === 8) {
        try {
            const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
            const data = response.data;
            if (data.erro) throw new Error('Cep inválido');
            return data;
        } catch {
            return null;
        }
    }

    return null;
};

const getHour = () => {
    return moment().format('HH:mm');
};

export default {
    formatMilliseconds(ms) {
        const duration = moment.duration(ms);
        const minutes = Math.floor(duration.asMinutes());
        const seconds = duration.seconds();
        return `${minutes}m ${seconds}s`;
    },
    setAccessibilityClass() {
        document.getElementsByTagName('html')[0].classList.add('accessibility');
    },
    removeAccessibilityClass() {
        document.getElementsByTagName('html')[0].classList.remove('accessibility');
    },
    exibApartir() {
        return this.getLocalConfigs('exibApartir') == true;
    },
    askPhoneNumber() {
        return this.getLocalConfigs('askPhoneNumber') == true;
    },
    variablePrice: function (prod) {
        // verifica se o produto principal não imprime no cupom
        if (prod.productPrint === 'N') {
            return true;
        }

        // verifica se alguma observaçao do produto principal possui preço
        if (prod.observationsChoice) {
            let observations = false;
            prod.observationsChoice.forEach((e) => {
                observations = e.observations.find((obs) => {
                    return obs.price > 0;
                });
            });
            if (observations) {
                return true;
            }
        }

        // verifica os produtos filhos, se houver
        if (prod.productGroups && prod.productGroups.length > 0) {
            // verifica se algum grupo promocional imprime no cupom
            let subGroupPrint = prod.productGroups.find((e) => {
                return e.productGroupPrint === 'S';
            });
            if (subGroupPrint) return true;

            // verifica se algum grupo promocional possui observações com preço
            let hasPricedObservations = false;
            prod.productGroups.forEach((group) => {
                if (group.productGroupItems && group.productGroupItems.length > 0) {
                    group.productGroupItems.forEach((item) => {
                        if (item.subItemObservationsChoice && item.subItemObservationsChoice.length > 0) {
                            item.subItemObservationsChoice.forEach((obsGroup) => {
                                if (obsGroup.subItemObservations && obsGroup.subItemObservations.length > 0) {
                                    obsGroup.subItemObservations.forEach((obs) => {
                                        if (obs.price > 0) {
                                            hasPricedObservations = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
            if (hasPricedObservations) return true;
        }

        return false;
    },
    getUrlImage(path) {
        return `${this.getBackAdress()}/${path}`;
    },
    logComunication(uri, dataObject, _respose) {
        let urlMenuCache = this.getBackAdress();
        console.log(urlMenuCache);
        let date = moment().format('DD/MM/YYYY - HH:mm:ss');
        let payload = JSON.stringify(dataObject);
        let response = JSON.stringify(_respose);
        let log = `${date} | URI: ${uri} \nPayload: ${payload} \nResponse: ${response}\n\n\n`;
        let posCode = this.getLocalConfigs('caixaCodigo');
        // axios.post(backAdress + 'functions/logger.php', `posCode=${posCode}&Log=${log}`)
        axios.post(urlMenuCache + '/generateLog', { device: 'TAA', posCode: posCode, log: log });
    },
    getAvailableInterfaces(endApache) {
        return axios.post(endApache + 'rest-api/');
    },
    getDateAsFormat(format) {
        return moment().format(format);
    },

    /**
     * Quebra um nível do objeto e o retorna como array
     *
     * */
    flatAnObjectList: function (obj) {
        return obj ? Object.values(obj).flat(1) : [];
    },

    /**
     * Store values into localStorage.
     *
     * @param {String} varName
     * @param {*} value
     */
    setLocalVar(varName, value) {
        if (!localStorage.getItem(varName)) {
            localStorage.setItem(varName, JSON.stringify({}));
        }
        localStorage.setItem(varName, JSON.stringify(value));
    },

    removeLocalVar(varName) {
        localStorage.removeItem(varName);
    },

    getLocalConfigs(value) {
        let config = JSON.parse(localStorage.getItem('taaconfig'));
        if (config) {
            return config[value];
        }
        return null;
    },

    isRecogMode() {
        return true;
    },

    isTapMode() {
        return this.getLocalConfigs('modotap') === true;
    },

    isBalancaMode() {
        return this.getLocalConfigs('modobalanca') === true;
    },

    isSlimMode() {
        return this.getLocalConfigs('slimMode') === true;
    },

    useBoldPrice() {
        return this.getLocalConfigs('boldPrice') === true;
    },

    allowAcessibilidade() {
        return this.getLocalConfigs('acessibilidade') === true;
    },

    allowProdBarCodeRead() {
        return this.getLocalConfigs('enableProdBarCodeRead') === true;
    },

    isEditMode() {
        return this.getLocalConfigs('isEditMode') === true;
    },

    isAndroidMode() {
        return this.getLocalVar('runningEnvironment') && this.getLocalVar('runningEnvironment').insideAndroid === true;
    },

    isNfseMode() {
        let curtaa = this.getLocalConfigs('curtaa');
        return curtaa != null && curtaa.useNFSe === 'S';
    },

    isGertecSk210() {
        return window.innerHeight < 800;
    },

    showConsumerLogin() {
        return true;
    },

    getGeneralInfo(force = false) {
        return {
            subsidiaryCode: this.getLocalConfigs('filialCodigo'),
            storeCode: this.getLocalConfigs('lojaCodigo'),
            posCode: this.getLocalConfigs('caixaCodigo'),
            consumerType: this.getLocalConfigs('consumidorTipo'),
            hour: moment().format('HH:mm'),
            force: force
        };
    },

    setLocalStoredColors() {
        let config = this.getLocalVar('taaconfig');
        if (config) {
            let r = document.querySelector(':root');
            r.style.setProperty('--primary-color', config.primary_color);
            r.style.setProperty('--primary-light', config.primary_light);
            r.style.setProperty('--primary-dark', config.primary_dark);
            r.style.setProperty('--header-color', config.header_color);
            r.style.setProperty('--categorie-color', config.categorie_color);
            r.style.setProperty('--categorie-font-color', config.categorie_font_color);
            r.style.setProperty('--cart-color', config.cart_color);
            r.style.setProperty('--cart-font-color', config.cart_font_color);
            r.style.setProperty('--price-font-color', config.price_font_color);
        }
    },

    /**
     * Show information notification
     *
     * @param {Object} message
     */
    showNotification(message) {
        notify({
            title: message.title,
            text: message.text
        });
    },

    /**
     * Show warning notification
     *
     * @param {Object} message
     */
    showWarningNotification(message) {
        notify({
            type: 'warn',
            title: message.title,
            text: message.text
        });
    },

    /**
     * Show error notification
     *
     * @param {Object} message
     */
    showErrorNotification(message) {
        notify({
            type: 'error',
            title: message?.title || message,
            text: message?.text
        });
    },

    showErrorNotificationFixed(message) {
        notify({
            type: 'error',
            title: message.title,
            text: message.text,
            duration: -1
        });
    },

    /**
     * Show success notification
     *
     * @param {Object} message
     */
    showSuccessNotification(message) {
        notify({
            type: 'success',
            title: message.title || message,
            text: message.text
        });
    },

    spliceOnCondition(array, callback) {
        var i = array.length;
        while (i--) {
            if (callback(array[i], i)) {
                array.splice(i, 1);
            }
        }
    },

    arrayToOjbect(source) {
        source = source || [];
        return source.reduce((acc, cur) => {
            let key = Object.keys(cur)[0];
            acc[key] = cur[key];
            return acc;
        }, {});
    },

    safeDecimalCalc: function (param1, param2, symbol) {
        let knowFunctions = {
            '+': (param1 * 100 + param2 * 100) / 100,
            '-': (param1 * 100 - param2 * 100) / 100
        };
        return knowFunctions[symbol];
    },

    deepCopy(source) {
        return JSON.parse(JSON.stringify(source));
    },
    isTimeToReloadFoodMenu() {
        if (this.getLocalConfigs('hotReload') === true) {
            return true;
        }
        if (
            (process.env.RESPECT_EXPIRATION_CONFIG === true && this.getLocalConfigs('cardapioExpira') == true) ||
            process.env.RESPECT_EXPIRATION_CONFIG === false
        ) {
            return moment().format('MMDDHH') != this.getLocalVar('lastSync');
        }
        return moment().format('MMDD') != this.getLocalVar('lastSync');
    },
    updateLastSync() {
        this.setLocalVar('lastSync', moment().format('MMDD'));
        if (
            (process.env.RESPECT_EXPIRATION_CONFIG === true && this.getLocalConfigs('cardapioExpira') == true) ||
            process.env.RESPECT_EXPIRATION_CONFIG === false
        ) {
            this.setLocalVar('lastSync', moment().format('MMDDHH'));
        }
    },
    mode,
    modeLength,
    sortBy,
    debounce,
    insertChar,
    maskFactory,
    showConfirmationDialog,
    showInfoModal,
    isInvalidNumber,
    formatMoney,
    isFosException,
    isComboDoCombo,
    getLocalVar,
    removeBlockedProds,
    removeHiddenProducts,
    removeHourlyUnavailableProds,
    sleep,
    interfaceVersionIsSupported,
    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    },
    getConfigImage(file) {
        let image = (this.getLocalConfigs('images') && this.getLocalConfigs('images')[file]) || null;
        return image ? `${this.getBackAdress()}/${image}` : null;
    },
    getBackAdress() {
        const { VUE_APP_BACKEND_URI: backendUri = '' } = process.env;
        if (backendUri.includes('http')) {
            return backendUri;
        }
        const { protocol, hostname } = window.location;
        if (backendUri && !backendUri.includes('<>')) {
            return `${protocol}//${hostname}${backendUri}`;
        }
        return `${protocol}//${hostname}`;
    },
    getAIdress() {
        const { VUE_APP_AI_URI: aiUri = '' } = process.env;

        if (aiUri.includes('http')) {
            return aiUri;
        }
        const { protocol, hostname } = window.location;
        if (aiUri && !aiUri.includes('<>')) {
            return `${protocol}//${hostname}${aiUri}`;
        }
        return `${protocol}//${hostname}`;
    },
    generateProdList(products) {
        let startTime = moment();
        let prodList = products
            .map((p) => {
                if (p.products && p.products.length > 0) {
                    let prods = p.products;
                    let subGroupProductItens = [];
                    prods.forEach((p) => {
                        (p.productGroups || []).forEach((pg) => {
                            let pgitens = pg.productGroupItems.map((pgi) => pgi).flat(1);
                            subGroupProductItens = subGroupProductItens.concat(pgitens);
                        });
                    });
                    return prods.concat(subGroupProductItens);
                } else if (p.subGroups && p.subGroups.length > 0) {
                    let subGroupProduct = p.subGroups.map((s) => s.products).flat(1);
                    let subGroupProductItens = [];
                    p.subGroups.forEach((p) => {
                        (p.productGroups || []).forEach((pg) => {
                            let pgitens = pg.productGroupItems.map((pgi) => pgi).flat(1);
                            subGroupProductItens = subGroupProductItens.concat(pgitens);
                        });
                    });
                    return subGroupProduct.concat(subGroupProductItens);
                } else {
                    return [];
                }
            })
            .flat(1);

        // window.lista = unicos
        // .reduce((acc, curr, index) => {
        //     acc[curr.productCode] = curr;
        //     return acc;
        // }, {})
        //.forEach(function(p) {prodList[p.productCode] = p})
        var duration = moment.duration(moment().diff(startTime));
        console.log(`Indexar todos os produtos levou ${duration.asSeconds()}s`);
        return prodList;
    },
    removePixSaquePixTroco: function (optionsArray) {
        let filteredOptions = optionsArray.filter((option) => option.name !== 'Pix Saque' && option.name !== 'Pix Troco');
        return filteredOptions;
    },
    showErrorScreen: function (router, errorType) {
        router.push({
            name: 'ErrorScreen',
            params: { errorType }
        });
        return true;
    },
    getImageList: function () {
        return [
            {
                id: 'espera',
                label: LocaleController.getString('imagem_tela_de_espera'),
                size: '(1080 x 1920)'
            },
            {
                id: 'logo',
                label: LocaleController.getString('logo'),
                size: '(400 x 150)'
            },
            {
                id: 'noImage',
                label: LocaleController.getString('produtos_sem_foto'),
                size: '(500 x 500)'
            },
            {
                id: 'toGo',
                label: LocaleController.getString('levar'),
                size: '(500 x 500)'
            },
            {
                id: 'comerAqui',
                label: LocaleController.getString('comer_aqui'),
                size: '(500 x 500)'
            },
            {
                id: 'pager',
                label: LocaleController.getString('instrucoes_pager'),
                size: '(1080 x 1920)'
            },
            {
                id: 'balancascreen',
                label: LocaleController.getString('instrucoes_balanca'),
                size: '(1080 x 1920)'
            },
            {
                id: 'tapscreen',
                label: LocaleController.getString('instrucoes_TAP'),
                size: '(1080 x 1920)'
            },
            {
                id: 'maquininha',
                label: LocaleController.getString('instrucoes_da_maquininha'),
                size: '(800 x 1000)'
            },
            {
                id: 'impressora',
                label: LocaleController.getString('instrucoes_da_impressora'),
                size: '(800 x 1000)'
            },
            {
                id: 'erroImpressora',
                label: LocaleController.getString('erro_de_impressora'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroSalvarVenda',
                label: LocaleController.getString('erro_ao_salvar_venda'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroTEF',
                label: LocaleController.getString('erro_de_pinpad'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroPinpad',
                label: LocaleController.getString('erro_pinpad_2'),
                size: '(1080 x 1920)'
            }
        ];
    },
    updateDefaultConfigs,
    getTLSTefConfig: function () {
        let config = {};
        let allParams = true;
        config.CDTOKENTLS = this.getLocalConfigs('tefToken');
        config.CDTPCOMUNTLS = this.getLocalConfigs('tefCommunic');
        config.CDTPPROXYTLS = this.getLocalConfigs('tefProxyType');
        config.CDENPROXYTLS = this.getLocalConfigs('tefEndProxy');
        Object.keys(config).forEach((e) => {
            console.log(config[e]);
            if (!config[e]) {
                allParams = false;
            }
        });
        return allParams ? config : null;
    },
    getFlagName: function (flag) {
        flag = flag.toLocaleLowerCase();

        const flagNames = [
            'alelo',
            'alipay',
            'american express',
            'amex',
            'aura',
            'diners',
            'discover',
            'elo',
            'hiper',
            'hipercard',
            'jcb',
            'maestro',
            'mastercard',
            'mir',
            'paypal',
            'sodexo',
            'unionpay',
            'visa'
        ];

        for (let i = 0; i < flagNames.length; i++) {
            const flagName = flagNames[i];
            if (flag.includes(flagName)) return flagName;
        }

        return '';
    },
    callWppHelp: function () {
        const NUMEROAJUDA = '';
        window.open(`https://api.whatsapp.com/send?phone=${NUMEROAJUDA}&text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20o%20QuickPass.`, '_blank');
        return false;
    },
    findCep,
    getHour,
    mapPlanoToConsumerType
};
